import ScriptText from "./ScriptText";
import { errorContent } from "@/data/content";
import { useContent } from "@/hooks/useContent";

export default function ErrorFallback() {
  const content = useContent("pages/error", errorContent);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-parchment px-6 text-center">
      <ScriptText className="mb-4 block text-4xl lg:text-5xl">
        {content.scriptAccent}
      </ScriptText>
      <p className="mx-auto mb-10 max-w-md font-body leading-relaxed text-soft-charcoal/70">
        {content.body}
      </p>
      <button
        onClick={() => window.location.reload()}
        className="inline-block cursor-pointer rounded-sm bg-faded-terracotta px-8 py-3 font-body text-xs tracking-[0.15em] uppercase text-parchment transition-all duration-500 hover:bg-fig"
      >
        {content.buttonText}
      </button>
    </div>
  );
}
